import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PlusIcon } from "lucide-react";
import { useLearner } from "../../contexts/LearnerContext";
import { Card } from "../ui/Card";
import { CourseRow } from "./CourseRow";
export function CourseList() {
  const {
    courses
  } = useLearner();
  const [openId, setOpenId] = useState<string | null>(null);
  return <Card as="section" labelledBy="courses-title" className="p-2 md:p-3" data-id="element-128" data-mp="3sc5fx57tgded">
      <div className="flex items-center justify-between px-3 pb-2 pt-3" data-id="element-129" data-mp="3se8eidn1beup">
        <h2 id="courses-title" className="text-lg font-bold tracking-[-0.01em] text-ink" data-id="element-130" data-mp="3nkne6exyy8sc">
          Your courses
        </h2>
        <span className="text-sm text-ink-2" data-id="element-131" data-mp="3ik9g9pq30f81">{courses.length} active</span>
      </div>
      <ul className="divide-y-2 divide-line/10" data-id="element-132" data-mp="3embn6bt6x8zd">
        {courses.map(c => <CourseRow key={c.id} course={c} open={openId === c.id} onToggle={() => setOpenId(id => id === c.id ? null : c.id)} data-id="element-133" data-mp="39kclr7h0gm52" />)}
      </ul>
      <Link to="/app/courses" className="focus-ring mt-2 flex items-center gap-3 rounded-xl border-3 border-dashed border-line/40 px-4 py-3.5 text-[15px] font-semibold text-ink-2 transition-colors duration-150 hover:border-line hover:text-ink" data-id="element-134" data-mp="30z4zzf06qor5">
        <span className="grid h-9 w-11 place-items-center rounded-xl border-2 border-line bg-sunken" data-id="element-135" data-mp="2wybc2lmqt9y9">
          <PlusIcon className="h-4 w-4" strokeWidth={2.75} data-id="element-136" data-mp="3kofeipo733no" />
        </span>
        Add a course — 60+ languages, many ways in
      </Link>
    </Card>;
}